<template>
  <v-container :fluid="isConciliacaoManual" class="pa-0">
    <router-view />
    <Footer v-if="!isConciliacaoManual"/>
  </v-container>
</template>

<script>
import Footer from "../components/common/Footer"
export default {
  name: 'Recebiveis',
  components: {
    Footer
  },
  // beforeMount() {
  //   let opts = {
  //     grupoEconomico: this.$store.state.permissions.grupoEconomico,
  //     modulo_operadora: "recebiveis"
  //   }
  //   this.$store.dispatch("permissions/getOperadoras", opts)
  // },
  computed: {
    isConciliacaoManual () {
      const path = this.$route.path
      const isConciliacaoManual = path.includes('conciliacao-manual')
      return isConciliacaoManual
    }
  }
}
</script>

<style>
</style>
